export var Language;

(function (Language) {
  Language["Ru"] = "ru";
  Language["En"] = "en";
})(Language || (Language = {}));

export var Ending;

(function (Ending) {
  Ending["User"] = "User";
  Ending["Group"] = "Group";
})(Ending || (Ending = {}));